<template>
  <div>
    <div class="card-box">
      <b-row class="align-items-center">
        <b-col md="12">
          <div class="flex align-items-center justify-content-between">
            <h4>Biometric KYC verification</h4>
            <c-switch
              class="mx-1"
              color="primary"
              v-model="localDataObj.enable"
              label
              variant="pill"
              data-on="|"
              data-off="|"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="localDataObj.enable">
        <b-col md="4"> <h5>Select Verification Methods</h5></b-col>
        <b-col>
          <eb-select
            type="select"
            :options="verificationOptions"
            label="label"
            id="docs"
            placeholder="Select Verification Methods"
            class="mt-0 currencyNameDropdown mb-0"
            v-model="selectedVerificationType"
            :selected="selectedVerificationType"
            @input="() => {}"
          ></eb-select>
        </b-col>
        <b-col md="1" class="text-center"
          ><img
            src="@/assets/images/add_icon.png"
            @click="addDocConfig"
            alt
                class="add-icon"
        /></b-col>
      </b-row>
      <div v-if="localDataObj.enable">
        <div v-for="(method, ind) in Object.keys(methodDataObj)" :key="ind">
          <b-row class="mt-2" v-if="method === 'faceScan'">
            <b-col md="12" v-if="ind">
              <div class="p-2">
                <h4 class="or-divider">OR</h4>
              </div>
            </b-col>
            <b-col md="4"
              ><h5>{{ findMethodLabel(method) }}</h5></b-col
            >
            <b-col md="7"
              ><eb-select
                type="select"
                :options="vidSizeOptions"
                label="label"
                id="maxSize"
                placeholder="Max Size in Byte"
                class="mt-0 currencyNameDropdown mb-0"
                v-model="methodDataObj[method].allowedVideoType"
                :selected="methodDataObj[method].allowedVideoType"
                @input="(e) => onSelectVidSize(e.value, method)"
              ></eb-select
            ></b-col>
            <b-col md="1" class="text-center"
              ><img
                src="@/assets/images/Trash.png"
                alt
                class="trash-icon"
                @click="RemoveType(method)"
            /></b-col>
          </b-row>
          <b-row class="mt-2" v-if="method === 'imageUpload'">
            <b-col md="12" v-if="ind">
              <div class="p-2">
                <h4 class="or-divider">OR</h4>
              </div>
            </b-col>
            <b-col md="4"
              ><h5>{{ findMethodLabel(method) }}</h5></b-col
            >
            <b-col md="7">
              <eb-select
                type="select"
                :options="allImageTypes"
                label="label"
                id="maxSize"
                placeholder="Max Size in Byte"
                class="mt-0 currencyNameDropdown mb-0"
                v-model="methodDataObj[method].allowedImageype"
                :selected="methodDataObj[method].allowedImageype"
                @input="(e) => onSelectImgType(e.value, method)"
              ></eb-select>
            </b-col>
            <b-col md="1" class="text-center"
              ><img
                src="@/assets/images/Trash.png"
                alt
                class="trash-icon"
                @click="RemoveType(method)"
            /></b-col>
          </b-row>
        </div>
      </div>

      <b-row
        class="mt-4 mb-3"
        v-if="localDataObj.enable && Object.keys(methodDataObj).length"
      >
        <b-col md="3"></b-col>
        <b-col md="3">
          <b-button variant="danger" class="tc-btn"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="3">
          <b-button variant="primary" class="tc-btn " @click="updateConfig"
            >SAVE</b-button
          >
        </b-col>
        <b-col md="3"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import { Switch as cSwitch } from "@coreui/vue";
import cInput from "@/components/Common/CustomInput";
export default {
  props: {
    dataObj: {
      default: () => {},
      type: Object,
    },
    userType: {
      default: "",
      type: String,
    },
  },
  components: {
    cSwitch,
    ebSelect,
    cInput,
  },
  data() {
    return {
      localDataObj: {},
      verificationOptions: [
        { label: "Face Scan", value: "faceScan" },
        { label: "Image Upload", value: "imageUpload" },
      ],
      selectedVerificationType: "",
      methodDataObj: {},
      allImageTypes: [
        { label: "JPG", value: "JPG" },
        { label: "JPEG", value: "JPEG" },
        { label: "PNG", value: "PNG" },
      ],
      vidSizeOptions: [
        { label: "5 Mb", value: "5mb" },
        { label: "10 Mb", value: "10mb" },
      ],
    };
  },
  computed: {
    userId() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
    },
  },
  methods: {
    syncLocalState() {
      this.localDataObj = JSON.parse(JSON.stringify(this.dataObj || {}));
      this.methodDataObj = {};
      Object.keys(this.localDataObj).forEach((el) => {
        if (typeof this.localDataObj[el] === "object" && this.localDataObj[el]) {
          this.methodDataObj[el] = { ...this.localDataObj[el] };
        }
      });
    },
    RemoveType(method) {
      if (Object.keys(this.methodDataObj).length === 1) {
        this.methodDataObj = Object.assign({});
      }
      Object.keys(this.methodDataObj).forEach((el) => {
        if (el !== method) {
          let obj = {};
          obj[el] = { ...this.methodDataObj[el] };
          this.methodDataObj = Object.assign({}, obj);
        }
      });
    },
    findMethodLabel(val) {
      let obj = this.verificationOptions.find((el) => el.value === val);
      return obj.label;
    },
    onSelectVidSize(val, method) {
      this.methodDataObj[method].allowedVideoType = val;
    },
    onSelectImgType(val, method) {
      this.methodDataObj[method].allowedImageype = val;
    },
    addDocConfig() {
      this.methodDataObj[this.selectedVerificationType.value] = {};
      if (this.selectedVerificationType.value === "faceScan") {
        this.methodDataObj[
          this.selectedVerificationType.value
        ].allowedVideoType = "";
      } else {
        this.methodDataObj[
          this.selectedVerificationType.value
        ].allowedImageype = "";
      }
      this.methodDataObj = Object.assign({}, this.methodDataObj);
      this.selectedVerificationType = "";
    },
    async updateConfig() {
      let payload = {
        kycVerification: {},
      };
      payload.kycVerification[this.userType] = {
        biometric: { ...this.methodDataObj, enable: this.localDataObj.enable },
      };
      try {
        await this.$store.dispatch("tenant/updateKycConfig", {
          id: this.userId,
          data: { ...payload },
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.syncLocalState();
  },
  watch: {
    dataObj: {
      deep: true,
      handler() {
        this.syncLocalState();
      },
    },
  },
};
</script>

<style scoped>
.or-divider {
  color: var(--primary);
}

.add-icon {
  cursor: pointer;
  width: 90%;
  margin-left: 0;
}

.trash-icon {
  cursor: pointer;
  width: 28px;
  height: 28px;
  min-width: 20px;
  min-height: 20px;
}
</style>
